import $http from "../axios";
import europeanCountriesWithVAT from "../assets/js/european-countries-with-vat";

const state = {
  stores: [],
  storeBeingManaged: {},
  countriesWithVAT: europeanCountriesWithVAT,
  vatValues: {
    PT: [
      { value: 23, name: "23%" },
      { value: 13, name: "13%" },
      { value: 6, name: "6%" },
      { value: 0, name: "0%" }
    ],
    AE: [{ value: 5, name: "5%" }]
  }
};

const getters = {
  stores: state => {
    return state.stores;
  },

  storeBeingManaged: state => {
    return state.storeBeingManaged;
  },

  merchantHasBuyNowPayLater: state => {
    let merchantHasBuyNowPayLater = false;
    for (let i = 0; i < state.stores.length; i++) {
      if (state.stores[i].configs.buyNowPayLater) {
        merchantHasBuyNowPayLater = true;
        break;
      }
    }
    return merchantHasBuyNowPayLater;
  },

  merchantHasOpenMartCameraMonitoring: state => {
    let merchantHasOpenMartCameraMonitoring = false;

    for (let i = 0; i < state.stores.length; i++) {
      if (
        state.stores[i].configs &&
        state.stores[i].configs.hasOpenMartCameraMonitoring
      ) {
        merchantHasOpenMartCameraMonitoring = true;
        break;
      }
    }

    return merchantHasOpenMartCameraMonitoring;
  },

  storeHasVAT: state => {
    return !state.storeBeingManaged || !state.storeBeingManaged.address
      ? false
      : state.countriesWithVAT.includes(
          state.storeBeingManaged.address.countryCode
        );
  },

  getVatValues: state => {
    return state.storeBeingManaged &&
      state.storeBeingManaged.address &&
      state.countriesWithVAT.includes(
        state.storeBeingManaged.address.countryCode
      )
      ? state.vatValues[state.storeBeingManaged.address.countryCode]
      : state.vatValues["PT"];
  },

  merchantHasVendings: state => {
    let merchantHasVendings = false;

    for (let s = 0; s < state.stores.length; s++) {
      if (state.stores[s].vendings.length > 0) {
        merchantHasVendings = true;
        break;
      }
    }

    return merchantHasVendings;
  },

  onlyVendings: state => {
    let onlyVendings = true;

    for (let s = 0; s < state.stores.length; s++) {
      if (!state.stores[s].storeInfo.vendingsOnly) {
        onlyVendings = false;
        break;
      }
    }

    return onlyVendings;
  },

  onlyCacauShowVendings: state => {
    let onlyCacauShowVendings = true;
    let merchantHasNoVendings = true;

    for (let s = 0; s < state.stores.length; s++) {
      if (state.stores[s].vendings.length > 0) {
        merchantHasNoVendings = false;
      }

      for (let v = 0; v < state.stores[s].vendings.length; v++) {
        if (
          !state.stores[s].vendings[v].vendingInfo ||
          (state.stores[s].vendings[v].vendingInfo &&
            !state.stores[s].vendings[v].vendingInfo.isCacauShow)
        ) {
          onlyCacauShowVendings = false;
          break;
        }
      }
    }

    if (state.stores.length === 0) onlyCacauShowVendings = false;

    if (merchantHasNoVendings) onlyCacauShowVendings = false;

    return onlyCacauShowVendings;
  }
};

const actions = {
  getStores({ commit }) {
    return new Promise((resolve, reject) => {
      $http
        .get(`stores`)
        .then(res => {
          if (res.data.result === "ok") {
            commit("SET_STORES", res.data.payload);
            commit(
              "SET_IS_PROMOTIONS_OPT_IN_ACTIVE",
              res.data.payload.isPromotionsOptInActive
            );
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  getDashboardToday(context, data) {
    return new Promise((resolve, reject) => {
      $http
        .get(`bi-dashboard-today`, { params: { ...(data || {}) } })
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  getDashboardProducts(context, data) {
    return new Promise((resolve, reject) => {
      $http
        .get(`bi-dashboard-products`, { params: { ...(data || {}) } })
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  getDashboardSales(context, data) {
    return new Promise((resolve, reject) => {
      $http
        .get(`bi-dashboard-sales`, { params: { ...(data || {}) } })
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  saveVoucherStatus(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`save-voucher-status`, data)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  updateStoreConfig(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`update-store-config`, data)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  setStoreBeingManaged({ commit }, store) {
    commit("SET_STORE_BEING_MANAGED", store);
  },

  clearStores({ commit }) {
    commit("CLEAR_STORES");
  }
};

const mutations = {
  SET_STORES(state, payload) {
    state.stores = payload.stores.map(s => {
      const accessDevices = s.accessDevices || [];
      const accessDevice =
        accessDevices.find(accessDevice => accessDevice.mainDevice) ||
        accessDevices[0];

      return {
        ...s,
        accessDevice,
        accessDevices,
        transactionsQty: payload.transactions
          ? payload.transactions.filter(t => {
              return t.store._id === s._id;
            }).length
          : [],
        accessesQty: payload.accesses
          ? payload.accesses.filter(a => {
              return a.device.store._id === s._id;
            }).length
          : [],
        feedbacksQty: payload.feedbacks
          ? payload.feedbacks.filter(f => {
              return f.store._id === s._id;
            }).length
          : [],
        ordersQty: payload.orders
          ? payload.orders.filter(f => {
              return f.store._id === s._id;
            }).length
          : []
      };
    });

    for (let i = 0; i < state.stores.length; i++) {
      if (!isNaN(state.stores[i].payments.ecommerce.cartValueLimit))
        state.stores[i].payments.ecommerce.cartValueLimit =
          state.stores[i].payments.ecommerce.cartValueLimit / 100;
    }
  },

  SET_STORE_BEING_MANAGED(state, store) {
    state.storeBeingManaged = store;
  },

  SET_STORE_STATUS(state, data) {
    state.stores[
      state.stores.findIndex(s => s._id === data.storeId)
    ].storeInfo.status = data.status;
  },

  CREATE_CASHBACK(state, data) {
    const sIndex = state.stores.findIndex(s => s._id === data.storeId);
    state.stores[sIndex].cashbacks.push(data.cashback);
    state.storeBeingManaged = state.stores[sIndex];
  },

  SET_CASHBACK_STATUS(state, data) {
    const isActive = data.success ? data.isActive : !data.isActive;
    const sIndex = state.stores.findIndex(s => s._id === data.storeId);
    const cIndex = state.stores[sIndex].cashbacks.findIndex(
      c => c._id === data.cashbackId
    );
    state.stores[sIndex].cashbacks[cIndex].isActive = isActive;
  },

  DELETE_CASHBACK(state, data) {
    const sIndex = state.stores.findIndex(s => s._id === data.storeId);
    const cIndex = state.stores[sIndex].cashbacks.findIndex(
      c => c._id === data.cashbackId
    );
    state.stores[sIndex].cashbacks.splice(cIndex, 1);
    state.storeBeingManaged = state.stores[sIndex];
  },

  CREATE_COUPON(state, data) {
    const sIndex = state.stores.findIndex(s => s._id === data.storeId);
    state.stores[sIndex].coupons.push(data.coupon);
    state.storeBeingManaged = state.stores[sIndex];
  },

  DELETE_COUPON(state, data) {
    const sIndex = state.stores.findIndex(s => s._id === data.storeId);
    const cIndex = state.stores[sIndex].coupons.findIndex(
      c => c._id === data.couponId
    );
    state.stores[sIndex].coupons.splice(cIndex, 1);
    state.storeBeingManaged = state.stores[sIndex];
  },

  UPDATE_COUPON(state, data) {
    const sIndex = state.stores.findIndex(s => s._id === data.storeId);
    const cIndex = state.stores[sIndex].coupons.findIndex(
      c => c._id === data.coupon._id
    );
    state.stores[sIndex].coupons[cIndex] = data.coupon;
    state.storeBeingManaged = state.stores[sIndex];
  },

  SET_NOTIFICATION_STATUS(state, data) {
    const index = state.stores.findIndex(s => s._id === data.storeId);
    state.stores[index].notifications.merchant[data.notificatioin] =
      data.status;
  },

  SET_ACCESS_WITHOUT_PAYMENT_METHODS(state, data) {
    const accessDeviceIds = data.accessDeviceIds || [data.accessDeviceId];
    const index = state.stores.findIndex(s =>
      (s.accessDevices || []).some(accessDevice => {
        return accessDeviceIds.includes(accessDevice._id);
      })
    );

    if (index < 0) return;

    state.stores[index].accessDevices = state.stores[index].accessDevices.map(
      accessDevice => {
        if (!accessDeviceIds.includes(accessDevice._id)) return accessDevice;

        return {
          ...accessDevice,
          openWithoutRegisteredPaymentMethods: data.status
        };
      }
    );

    if (
      state.storeBeingManaged &&
      state.storeBeingManaged._id === state.stores[index]._id
    ) {
      state.storeBeingManaged = state.stores[index];
    }
  },

  SET_OPEN_DOOR_BUTTON_IN_CART(state, data) {
    const index = state.stores.findIndex(s => s._id === data.storeId);
    state.stores[index].configs.showOpenDoorButtonInCart = data.status;
  },

  SET_NOTIFICATION(state, data) {
    const index = state.stores.findIndex(s => s._id === data.storeId);
    state.stores[index].notifications.merchant[data.notification] = data.status;
  },

  PARTICIPATE_PROMOTION(state, data) {
    const index = state.stores.findIndex(s => s._id === data.storeId);
    state.stores[index].promotions[data.promotion] = data.status;
  },

  UPDATE_PROMOTIONAL_IMAGE_LINK(state, data) {
    const index = state.stores.findIndex(s => s._id === data.storeId);
    if (!state.stores[index].promotions.promotionalImage) {
      state.stores[index].promotions.promotionalImage = {
        link: data.link
      };
    } else {
      state.stores[index].promotions.promotionalImage.link = data.link;
    }
  },

  UPDATE_PROMOTIONAL_IMAGE_STATUS(state, data) {
    const index = state.stores.findIndex(s => s._id === data.storeId);
    state.stores[index].promotions.promotionalImage.isActive = data.status;
  },

  UPDATE_PROMOTIONAL_IMAGE_DATE(state, data) {
    const index = state.stores.findIndex(s => s._id === data.storeId);
    state.stores[index].promotions.promotionalImage[data.date] = data.value;
  },

  SET_SHOW_CATALOG(state, data) {
    const index = state.stores.findIndex(s => s._id === data.storeId);
    state.stores[index].configs.showCatalog = data.status;
  },

  SET_SHOW_CATALOG_OUTSIDE_STORE(state, data) {
    const index = state.stores.findIndex(s => s._id === data.storeId);
    state.stores[index].configs.showCatalogOutsideStore = data.status;
  },

  SET_SHOW_STOCK_QTY(state, data) {
    const index = state.stores.findIndex(s => s._id === data.storeId);
    state.stores[index].configs.showStockQty = data.status;
  },

  SET_PRODUCT_ADDITION_VIA_CATALOG(state, data) {
    const index = state.stores.findIndex(s => s._id === data.storeId);
    state.stores[index].configs.addProductViaCatalog = data.status;
  },

  SET_ECOMMERCE_PAYMENT(state, data) {
    const index = state.stores.findIndex(s => s._id === data.storeId);
    state.stores[index].payments.ecommerce.isActive = data.status;
  },

  SET_ECOMMERCE_CART_VALUE_LIMIT_ACTIVE(state, data) {
    const index = state.stores.findIndex(s => s._id === data.storeId);
    state.stores[index].payments.ecommerce.isCartValueLimitActive = data.status;
  },

  SET_ECOMMERCE_CART_VALUE_LIMIT(state, data) {
    const index = state.stores.findIndex(s => s._id === data.storeId);
    state.stores[index].payments.ecommerce.cartValueLimit =
      data.cartValueLimit / 100;
  },

  SET_DEFAULT_VAT(state, data) {
    const index = state.stores.findIndex(s => s._id === data.storeId);
    state.stores[index].taxes.defaultVAT = data.defaultVAT;
  },

  SET_SEARCH_NOT_FOUND_PRODUCTS_IN_MY_OTHER_STORES(state, data) {
    const index = state.stores.findIndex(s => s._id === data.storeId);
    state.stores[index].configs.searchNotFoundProductsInMyOtherStores =
      data.status;
  },

  SET_ALLOW_LIST_ACCESS_RESTRICTION(state, data) {
    const index = state.stores.findIndex(s => s._id === data.storeId);
    state.stores[index].configs.restrictAccessToAllowList = data.status;
  },

  CLEAR_STORES(state) {
    state.stores = {};
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
